import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import * as Sentry from '@sentry/react'

const { logger } = Sentry;
import './CTABanner.scss'

function CTABanner() {
  const { loginWithPopup, isAuthenticated } = useAuth0()
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard')
    }
  }, [isAuthenticated, navigate])

  const handleGetStarted = async () => {
    setIsLoading(true)
    try {
      const width = 700
      const height = 900
      const left = window.screen.width / 2 - width / 2
      const top = window.screen.height / 2 - height / 2
      
      const popup = window.open(
        '',
        'auth0:authorize:popup',
        `width=${width},height=${height},left=${left},top=${top},resizable,scrollbars=yes,status=1`
      )
      
      await loginWithPopup({
        authorizationParams: {
          screen_hint: 'signup'
        }
      }, { popup } as any)
      // Navigation will happen via useEffect when isAuthenticated becomes true
    } catch (error) {
      logger.error('Login error', {
        error: error instanceof Error ? error.message : String(error),
      });
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <section 
      className="py-5 bg-light cta-banner-section"
      style={{
        backgroundImage: "url('/images/background2.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            {/* Dark banner card */}
            <div className="bg-dark rounded-4 p-4 p-md-5 mb-5 cta-banner-card">
              <div className="row align-items-center g-4">
                {/* Left side - Text and button */}
                <div className="col-md-6">
                  <h2 
                    className="text-white fw-bold mb-4"
                    style={{
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, Helvetica, sans-serif",
                      fontSize: '32px',
                      lineHeight: '40px',
                      letterSpacing: '-0.02em'
                    }}
                  >
                    Ready to land your next interview?
                  </h2>
                  <button
                    type="button"
                    className="btn btn-primary btn-lg text-uppercase fw-bold"
                    aria-label="Get started with JobsReadyAI for free"
                    onClick={handleGetStarted}
                    disabled={isLoading}
                  >
                    {isLoading ? 'Loading...' : 'Get started for free'}
                  </button>
                </div>
                {/* Right side - Image */}
                <div className="col-md-6">
                  <img 
                    src="/images/dashboard.png" 
                    alt="JobsReadyAI features and benefits for job seekers" 
                    className="img-fluid rounded-end-4"
                    style={{ width: '100%', height: 'auto' }}
                  />
                </div>
              </div>
            </div>

           
          </div>
        </div>
      </div>
    </section>
  )
}

export default CTABanner
